<template>
  <div class="over-time-confirm">
    <loading :show="isLoading" position="absolute"></loading>
    <group>
      <popup-picker placeholder="请选择客户到店情况" v-model="selectedItem" :data="list" @on-hide="onHide"></popup-picker>
    </group>
    <group>
      <datetime
        v-if="isArrived"
        v-model="arrivedTime"
        format="HH:mm"
        title=''
        confirm-text="确认"
        cancel-text="取消"
        placeholder="请选择到店时间">
      </datetime>
      <x-textarea v-if="isArrived === false" placeholder="请输入客户未到店原因" v-model="overTimeMsg"></x-textarea>
    </group>
    <div class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" @click.stop="onSubmit()">确认</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Group, PopupPicker, XTextarea, Datetime, Loading } from '@lx-frontend/cvux'
import dayjs from 'dayjs'

export default {
  components: {
    Group,
    PopupPicker,
    XTextarea,
    Datetime,
    Loading
  },
  data() {
    return {
      overTimeMsg: '',
      arrivedTime: '',
      list: [['客户已到店', '客户未到店']],
      selectedItem: [],
      isArrived: undefined,
      isLoading: false
    }
  },
  async mounted () {
    this.$store.state.promiseAuth.then(data => {
      const arrivalAuth = data.authList.includes('service_booking.modify_customer_enter_status')
      if (!arrivalAuth) this.list = [['客户未到店']]
    })
  },
  methods: {
    async onSubmit() {
      if (this.selectedItem.length === 0) {
        this.showToast('请选择客户到店情况')
        return
      }
      if (this.selectedItem[0] === '客户未到店' && this.overTimeMsg === '') {
        this.showToast('请输入客户未到店原因')
        return
      }
      if (this.selectedItem[0] === '客户已到店' && this.arrivedTime === '') {
        this.showToast('请选择客户实际到店时间')
        return
      }
      const isFullFill = this.selectedItem[0] === '客户已到店'
      const params = {
        action: isFullFill ? 'fulfill' : 'over_fulfill',
        reason: this.overTimeMsg,
        fulfilled_at: dayjs(`${dayjs().format('YYYY-MM-DD')} ${this.arrivedTime}`).format('YYYY-MM-DD HH:mm:ss'),
        fulfill_type: 2
      }
      this.isLoading = true
      const id = this.$route.params.id
      const res = await this.$rest.appointment.updateAppointmentStatus(id)(params)
      if (res.code === 0) {
        this.isLoading = false
        this.showToast('提交成功')
        this.$router.go(-1)
      } else {
        this.showToast(res.message)
      }
    },
    onHide() {
      if (this.selectedItem.length > 0) {
        if (this.selectedItem[0] === '客户已到店') {
          this.isArrived = true
        } else {
          this.isArrived = false
        }
      }
    }
  }
}
</script>

<style lang="less">
</style>
